import React from "react";

//ANT DESIGN IMPORTS
import { Input, Row, Typography, Form, Card, Col } from "antd";

//PROJECT IMPORTS
import appLabel from "../../../../../config/appLabel";

const { Text } = Typography;

export default function DetailsForm({ redeDetail }) {
  const [useForm] = Form.useForm();

  return (
    <Form layout="vertical" form={useForm}>
      <Card
        style={{
          marginBottom: "2%",
          boxShadow: "0px 0px 30px 5px rgba(0,0,0,0.025)",
          padding: 10,
        }}
      >
        <Row>
          <Col span={8} style={{ padding: "0px 8px" }}>
            <Form.Item label={<Text strong>{appLabel.productName}</Text>}>
              <Input disabled className="of-bold-disable-input" value={redeDetail?.name} />
            </Form.Item>
          </Col>
          <Col span={8} style={{ padding: "0px 8px" }}>
            <Form.Item label={<Text strong>{appLabel.shortName}</Text>}>
              <Input disabled className="of-bold-disable-input" value={redeDetail?.shortName} />
            </Form.Item>
          </Col>
          <Col span={8} style={{ padding: "0px 8px" }}>
            <Form.Item label={<Text strong>{appLabel.description}</Text>}>
              <Input.TextArea
                disabled
                className="of-bold-disable-input"
                value={redeDetail?.description}
              ></Input.TextArea>
            </Form.Item>
          </Col>
          <Col span={8} style={{ padding: "0px 8px" }}>
            <Form.Item label={<Text strong>Status</Text>}>
              <Input.TextArea
                className="of-bold-disable-input"
                disabled
                value={redeDetail?.active ? "Active" : "Inactive"}
              ></Input.TextArea>
            </Form.Item>
          </Col>
        </Row>
      </Card>
    </Form>
  );
}
